export const howGetData = [
  {
    id: 1,
    icon: require("../../../image/cryptolicense/hw-img-one.webp"),
    title: "Company Registration",
    description:
      "Register your company under Indian law (Private Limited or LLP).",
  },
  {
    id: 2,
    icon: require("../../../image/cryptolicense/hw-img-two.webp"),
    title: "Apply for FIU Registration",
    description:
      "Register with the Financial Intelligence Unit (FIU-IND) as a reporting entity.",
  },
  {
    id: 3,
    icon: require("../../../image/cryptolicense/hw-img-three.webp"),
    title: "KYC/AML Compliance",
    description:
      "Implement AML (Anti-Money Laundering) policies & KYC (Know Your Customer) Policy.",
  },
  {
    id: 4,
    icon: require("../../../image/cryptolicense/hw-img-four.webp"),
    title: "GST Registration",
    description: "Apply for GST and pay applicable taxes.",
  },
  {
    id: 5,
    icon: require("../../../image/cryptolicense/hw-img-five.webp"),
    title: "Data Protection",
    description:
      "Ensure compliance with Indian data privacy regulations to protect user information.",
  },
  {
    id: 6,
    icon: require("../../../image/cryptolicense/hw-img-six.webp"),
    title: "Banking Support",
    description: "Partner with banks for fiat transactions.",
  },
];

export const licenseCostIndia = [
  {
    id: 1,
    content: "Company registration fees",
  },
  {
    id: 2,
    content: "Legal and consulting charges",
  },
  {
    id: 3,
    content: "KYC/AML software tools",
  },
  {
    id: 4,
    content: "FIU Registration fees",
  },
  {
    id: 5,
    content: "Compliance and audit",
  },
];

export const stepsData = [
  {
    id: 1,
    num: "01.",
    content: "Incorporate as a private limited company or LLP",
    img: require("../../../image/cryptolicense/step-img-one.webp"),
  },
  {
    id: 2,
    num: "02.",
    content: "Register with FIU-IND",
    img: require("../../../image/cryptolicense/step-img-two.webp"),
  },
  {
    id: 3,
    num: "03.",
    content:
      "Follow RBI and SEBI advisory guidelines (though crypto is not directly regulated by these)",
    img: require("../../../image/cryptolicense/step-img-three.webp"),
  },
  {
    id: 4,
    num: "04.",
    content: "Set up robust KYC/AML compliance",
    img: require("../../../image/cryptolicense/step-img-four.webp"),
  },
  {
    id: 5,
    num: "05.",
    content: "Appoint a compliance officer",
    img: require("../../../image/cryptolicense/step-img-five.webp"),
  },
];

export const cryptoTradingCost = [
  {
    id: 1,
    content: "Size of the company",
  },
  {
    id: 2,
    content: "Legal consultations",
  },
  {
    id: 3,
    content: "Registration and license fees",
  },
  {
    id: 4,
    content: "KYC and AML systems",
  },
  {
    id: 5,
    content: "Infrastructure and staff",
  },
];

export const benefitsData = [
  {
    id: 1,
    content: "0% income tax",
  },
  {
    id: 2,
    content: "Fast company setup",
  },
  {
    id: 3,
    content: "Access to global crypto investors",
  },
  {
    id: 4,
    content: "Trusted legal framework",
  },
  {
    id: 5,
    content: "Full ownership (in Free Zones)",
  },
];
